/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityParticipationThresholdBasis {
    TOTAL_SOURCES_FOR_ISSUER = 'TOTAL_SOURCES_FOR_ISSUER',
    TOTAL_PROCEEDS_WITHIN_TIER = 'TOTAL_PROCEEDS_WITHIN_TIER',
}
